import translation from '@elements/translation';

export default {
  mixins: [ translation ],
  props: {
    deal: { type: Object, required: true },
  },
};
